import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';

const initialState = {
  territoryList: [],
  status: false,
  error: null,
};

export const fetchTerritoryList = createAsyncThunk(
  'master/fetchTerritoryList',
  async () => {
    const response = await ApiService.get(`/system/territory/list`);
    return response?.data || [];
  }
);

const territorySlice = createSlice({
  name: 'territoryList',
  initialState,
  reducers: {
    clearTerritoryList: state => {
      state.territoryList = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTerritoryList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchTerritoryList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.territoryList = action?.payload || [];
      })
      .addCase(fetchTerritoryList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { clearTerritoryList } = territorySlice.actions;

export const territoryReducer = territorySlice.reducer;
